define('drops/text/text',[
    'jquery',
    'lq',
    'lq/html',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/tooltip',
    'lq/onlongpress'
], function ($, lq, html, Drop, Style, util, Tooltip, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            text: 'New Text',
            useDynamicWidth: true,
            useDynamicHeight: true,
            openInline: false,
            scrollbarOnOverflow: false,
            title: {
                option: Tooltip.hardcoded
            },
            renderAsHtml: false
        }
    };

    function Text(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.rerenderText();

        if (this.data.scrollbarOnOverflow)
            this.$element.css('overflow-y', 'auto');

        Style.renderStyles(this);

        if (!this.designData && this.isEventEnabled('onLongPress')) {
            this.$element.addClass('clickable');
            OnLongPress.applyLongPressOnElement(this.$element, this);
        } else if (this.data.eventing && this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            this.applyEventTrigger('clicked', 'click');
            this.$element.addClass('clickable');
        }

        this.applyEventTrigger('mouseEnter', 'mouseenter');

        this.tooltip = new Tooltip(this, this.data.title, this.$element);
    }

    Drop.extend(Text, Drop);

    Text.typeName = 'Text';

    Text.prototype.rerenderText = function () {
        this.$text = this.createTextElement();
        this.$element.empty();
        this.$element
            .addClass('boxToBorderSize drop-text-container')
            // WHY setting 'display: table' on $element would break centered anchoring, so we have to add a wrapper
            .append($('<div />')
                .css({
                    display: 'table',
                    whiteSpace: 'pre-wrap',
                    position: 'relative',
                    height: '100%',
                    width: '100%',
                    overflowY: 'auto'
                })
                .append(this.$text));

        this.$text
            .addClass('drop-text-content')
            .css({
                display: 'table-cell'
            });
    };

    Text.prototype.createTextElement = function () {
        var text = this.data.text;
        var $textElement;

        if (this.data.hyperlink && !this.designData) {
            $textElement = $('<a/>')
                .prop('href', util.convertRelativeHyperlinkToHostName(this.data.hyperlink))
                .prop('target', this.data.openInline ? '_self' : '_blank')
                .css({
                    height: '100%'
                });
        } else {
           $textElement = $('<div/>')
                .css({
                    height: '100%'
                });
        }

        if (this.data.renderAsHtml) {
            if (text) {
                var regex = new RegExp('{{{TenantUrl}}}', 'g');
                text = text.replace(regex, lq.getTenantUrl(''));
            }

            return $textElement
                .html(text || '')
                .css('whiteSpace', 'normal');
        } else {
            return $textElement.text(text);
        }
    };

    Text.prototype.postRender = function () {
        this.tooltip.update();
        this.piping.visibility.apply(this);

        this.applyPosition();

        if (this.data.applyBestFontFit || false) {
            Style.bestFontSize(this.$element[0], this.$text);
        }
    };

    Text.prototype.postWindowResize = function () {
        if (this.data.applyBestFontFit || false) {
            Style.bestFontSize(this.$element[0], this.$text);
        }
    };

    return Text;
});
